import {fetchHelper, setToken, simulateDelay} from '../utils/requestUtils';

export const getSourceMany = async (sourceTypeKey) => {
    await simulateDelay();
    let urlBuilder = "/sources/getMany?"
    urlBuilder += `&sortColumn=source_name`;
    urlBuilder += `&sortDirection=1`;
    if (sourceTypeKey) urlBuilder += `&sourceTypeKey=${sourceTypeKey}`
    const response = await fetchHelper({
        method: "GET",
        url: urlBuilder
    })
    return response;
}

export const submitCreateSource = async (input) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "POST",
        url: "/sources/create",
        reqBody: {
            sourceTypeKey: input.source_type_key,
            sourceName: input.source_name,
        }
    })
    return response;
}

export const submitUpdateSource = async (input) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "PUT",
        url: "/sources/update",
        reqBody: {
            sourceTypeKey: input.source_type_key,
            sourceName: input.source_name,
            originalKey: input.original_key,
        }
    })
    return response;
}

export const submitArchiveSource = async (input) => {
    await simulateDelay();
    const response = await fetchHelper({
        method: "PUT",
        url: "/sources/archive",
        reqBody: {
            sourceKey: input.source_key,
            isArchived: input.is_archived,
        }
    })
    return response;
}
